/**
 * @mockdata
 * 详细 mock 语法参见 https://github.com/nuysoft/Mock/wiki/Syntax-Specification
 */
import { RateDetail } from "./rate";
import { TaskList } from "./cleaner";
import { SubscriptionOverview } from "./subscription";

export const MockData = {
  "@ignore /api/thirdparty/account_login": {
    error_code: 213004,
    error_msg: "爱彼迎人机交互验证",
    data: {
      //   geetest: {
      //     airlock_id: -3115774136634229,
      //     flow: "captcha_flow",
      //     recaptcha: {
      //       verify_key: "1591798273_ODA1NDg4ODgxMTI3",
      //       data: {
      //         site_key: "6Lf20R0UAAAAAJDj8fQYXmFJWTbSPtvhtjV0VFoy",
      //         android_site_key: "6LdAOmsUAAAAADtHajb3Pq1hy547UPtrEKrT6dNq",
      //       },
      //       url:
      //         "https://www.airbnb.com/airlock?al_id=-3115774136634229&key=d306zoyjsyarp7ifhu67rjxn52tv0t20&sid=1:1591798274:MTY0NmE1ZjMwY2I3NDk2M2E3NzU5ZDZhOTI0ZTY3MjcxNTg5MWE1Zg==--1646a5f30cb74963a7759d6a924e672715891a5f",
      //     },
      //   },
      //   "booking": {
      //     "call": [
      //       {
      //         "id": "c5254f356709d241c847896a3ecf6dc3",
      //         "phone": "+86*******0090"
      //       }
      //     ],
      //     "sms": [
      //       {
      //         "id": "c5254f356709d241c847896a3ecf6dc3",
      //         "phone": "+86*******0090"
      //       }
      //     ]
      //   },
      zhenguo: {
        question: "手机短信验证",
        type: "sms",
        sms: [
          {
            id: "17dc51f5b0954c34813b5b72b9428a3a",
            phone: "130*****765",
          },
        ],
      },
      //   "geetest": {
      //     "airlock_id": 1754,
      //     "flow": "captcha_flow",
      //     "china_captcha": {
      //         "gt": "842cc17081653d0e7cf4bde73f80e4a9",
      //         "challenge": "d77b3f95ddc0664469c05edf86716b0b"  //需要作为verify_key回传
      //     }
      // }
    },
  },
  "@ignore /api/member/detail": {
    error_code: 0,
    error_msg: "",
    data: {
      house_quantity: 2691,
      current: {
        id: 1,
        operator_id: 10265,
        edition: 1,
        quantity: 2800,
        period: 12,
        start_time: "2019-11-29 16:45:42",
        expire_time: "2024-11-07 16:45:42",
        rest_days: 1,
      },
      status: 1,
      next: [],
    },
  },
  "@ignore /api/member/order/prepay": {
    error_code: 200,
  },
  "@ignore /api/member_promotion/list": {
    error_code: 0,
    error_msg: "",
    data: {
      "list|3-5": [
        {
          code: "F90F10DEFAE64372A55451D9C149D9EF",
          "status|1": [0, 3], //状态。 0:未使用 1:已使用 2:已禁用 3:已过期； 此列表仅展示0、3状态
          type: 1, //优惠券类型。 0:试用期延长（不在列表展示） 1:打折 2:满减 3: 代金券
          payload: {
            percent: "50", //折扣百分比 例: 50%
          },
          start_time: "2020-06-12 15:55:35",
          end_time: "2020-06-12 15:55:35",
          take_time: "2020-06-12 16:22:51",
        },
        {
          code: "57ECFE2A59654DD0B4B68651B0B926F5",
          "status|1": [0, 3],
          type: 2,
          payload: {
            reach: 100, //满
            reduce: 1, //减
            currency: "CNY", //币种
          },
          start_time: "2020-06-12 15:55:35",
          end_time: "2020-06-18 15:55:35",
          take_time: "2020-06-12 16:22:12",
        },
        {
          code: "B8AB0856F33549F490E86A181B1E3535",
          "status|1": [0, 3],
          type: 3,
          payload: {
            currency: "CNY", //币种
            amount: "20", //抵扣金额
          },
          start_time: "2020-06-12 15:55:35",
          end_time: "2020-07-18 15:55:35",
          take_time: "2020-06-12 16:19:42",
        },
      ],
      total: 4,
    },
  },
  "@ignore /api/member/order/payment_detail": {
    error_code: 200001,
  },
  "@ignore /api/checkin_guide/info/4C82F949F747471CA68B6918540B5362": {
    request_id: "RT1594805751103440",
    error_code: 0,
    error_msg: "",
    data: {
      guide_info: {
        logo: "https://oss.image.xiaogetech.com/MMG1591780727486.jpg/small",
        greet_content: "你好。欢迎关联hostex",
        house_title: "111111111111111111111",
        check_in: "2020-07-26",
        check_out: "2020-07-27",
        need_credential: 1,
        step: 1,
        address: {
          //模块名 为null时表示没有，就不展示了
          address: "北京永泰庄",
          log_address: null,
          lat_address: 32.56,
          address_remarks: null, //null表示没有
        },
        lock: {
          lock_password: "123456", //可能为“暂无”  "暂不可见"
          lock_remarks: null, //null 表示没有
        }, //模块名 为null时表示没有，就不展示了
        wifi: {
          wifi_name: "xiaoge",
          wifi_password: "wwpg",
          wifi_remarks: null, //null表示没有
        },
        detail_guide: {
          detail_guide_url: "https://www.myhostex.com",
          detail_guide_remarks: null, //null表示没有
        },
        phone: {
          phone: "18811755844",
          phone_remarks: null, //null表示没有
        },
      },
    },
  },
  "@ignore /api/customer_service/chat/service_list": {
    request_id: "RT1600154504915604",
    error_code: 0,
    error_msg: "",
    data: {
      list: [
        {
          id: 1, //转接时传此id
          operator_id: 10008,
          status: 1, //1=在线 0=掉线
          active: 1, //是否启用
          is_super_server: false,
          avatar: "https://xg-storage.oss-cn-beijing.aliyuncs.com/VUM1583489446473.jpeg",
          name: "sadfasdf",
        },
        {
          id: 1, //转接时传此id
          operator_id: 10008,
          status: 0, //1=在线 0=掉线
          active: 1, //是否启用
          is_super_server: false,
          avatar: "https://xg-storage.oss-cn-beijing.aliyuncs.com/VUM1583489446473.jpeg",
          name: "sadfasdf",
        },
      ],
    },
  },
  "@ignore /api/chat/list": {
    request_id: "RT1601179654856060",
    error_code: 0,
    error_msg: "",
    data: {
      list: [
        {
          id: "0-941734798",
          thirdparty_type: 0,
          thirdparty_account_id: 177373,
          origin_update_time: "2020-09-27 07:39:30",
          last_message_time: "2020-09-27 07:39:30",
          text_preview: "您需要先加下我微信",
          create_time: "2020-09-27 07:37:38",
          update_time: "2020-09-27 07:39:55",
          unread_count: 0,
          is_unfinished: 0,
          is_top: 0,
          house_info: {
            link_type: "house", //关联类型，可空。枚举:"house";"house_type";null
            link_id: 11166164, //关联id，可空。
            title: "2四期南洋海韵林居|85-4-401", //标题
          },
          booking_info: {
            link_type: "reservation", //关联类型，可空。 枚举:"reservation";null
            link_id: "0-HMCSK3PAPB-5f6fd0c7aa733", //关联id，可空。
            status: "inquiring", //状态。 枚举:"inquiring"; "wait_stay"; "staying"; "completed"; "cancelled"
            title: "咨询 09-30~10-03", //标题
          },
          host_info: {
            id: "0-257369004",
            thirdparty_type: "0",
            origin_customer_id: "257369004",
            name: "向海",
            photo:
              "https://z1.muscache.cn/im/pictures/user/ac8a2be9-6a73-41e2-9ebb-26337d66a50d.jpg?aki_policy=profile_x_medium",
            email: "",
          },
          tenant_info: {
            id: "0-247329156",
            thirdparty_type: "0",
            origin_customer_id: "247329156",
            name: "喆",
            photo:
              "https://z1.muscache.cn/im/pictures/user/505abb30-0ee1-4eca-b207-5dae1fa6f098.jpg?aki_policy=profile_x_medium",
            email: "user-j3ejk5jkabclrq8b@guest.airbnb.com",
          },
        },
      ],
      has_more: 1,
    },
  },

  "@ignore /api/reservation_comment/detail": RateDetail,
  "@ignore /api/schedule/staff_client/tasks": TaskList,
  "@ignore /api/subscription/plan/overview": SubscriptionOverview,
};
